<template>
  <div class="demoPage">
    <waves></waves>
    
  </div>
</template>

<script>


export default {
  
  data () {
    return {
     
    }
  },
}
</script>
<style lang="stylus">
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
.demoPage
  width 100%
  height 100%
  position relative
  background rgba(240,239,237,1) url('~assets/img/corrugatedBg.png') left bottom repeat-x
  background-size 1920px 425px
</style>